import Vue from 'vue'
import Vuex from 'vuex'
// import LogRocket from 'logrocket'
// LogRocket.init('zoutzk/salimb2b')
// import createPlugin from 'logrocket-vuex'
// const logrocketPlugin = createPlugin(LogRocket)
// import axios from 'axios'
// isAuth si l'utilisateur est connecte
// userfinformation les information de l'utilisateur
import user from './modules/user'
import appelOffre from './modules/appelOffre'
import route from './modules/route'
import abonnement from './modules/abonnement'
import header from './modules/header'
import entreprise from './modules/entreprise'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    user,
    appelOffre,
    route,
    abonnement,
    header,
    entreprise
  } // ,
  // plugins: [logrocketPlugin]
})



// WEBPACK FOOTER //
// ./src/components/store/DataStore.js